export default "__VITE_ASSET__8RaQ_lQD__"